import { makeStyles } from '@mui/styles';
import classNames from 'classnames';
import React from 'react';

import RuntimeRepositoryZoom from './ssRuntimeRepositoryZoom';
import ControlChangesIcon from '../../components/ControlChangesIcon';
import { FCM_BORDER_STYLES, FCM_HIDDEN_CONTROL_STYLES } from '../../constants/runtime.constants';

const useStyles = makeStyles({
  root: {
    display: 'flex',
  },
  changesModeWrapper: {
    display: 'flex',
    paddingTop: 4,
    border: FCM_BORDER_STYLES.CONDITIONAL,
  },
  control: {
    paddingTop: 18,
  },
  hiddenControl: FCM_HIDDEN_CONTROL_STYLES,
  changesIcon: {
    paddingRight: 8,
  },
});

const SSRepositoryZoom = ({
  isEditor,
  isControlHiddenFCM,
  isControlAddedFCM,
  isControlChangedFCM,
  ...props
}) => {
  const classes = useStyles({ isControlAddedFCM });

  if (isControlAddedFCM || isControlChangedFCM) {
    return (
      <div className={classes.root}>
        <div className={classes.changesModeWrapper} data-ss-id={props.id}>
          <div
            className={classNames(classes.control, isControlHiddenFCM ? classes.hiddenControl : '')}
            data-hidden-fcm={isControlHiddenFCM}
          >
            <RuntimeRepositoryZoom {...props} />
          </div>
          {isControlChangedFCM && (
            <div className={classes.changesIcon}>
              <ControlChangesIcon id={props.id} />
            </div>
          )}
        </div>
      </div>
    );
  }

  if (isControlHiddenFCM) {
    return (
      <div className={classes.hiddenControl} data-hidden-fcm="true">
        <RuntimeRepositoryZoom {...props} />
      </div>
    );
  }

  return <RuntimeRepositoryZoom {...props} isEditor={isEditor} />;
};

export default SSRepositoryZoom;
